import {get as getProjection} from 'ol/proj';

export const DEFAULT_DPI = 25.4 / 0.28;
export const DEFAULT_SCREEN_DPI = 72; //96

export const METERS_PER_UNIT = {
    'm': 1,
    'degrees': 111194.87428468118,
    'ft': 0.3048,
    'us-ft': 1200 / 3937
};

export const GOOGLE_MERCATOR = {
    RADIUS: 6378137,
    TILE_WIDTH: 256,
    ZOOM_FACTOR: 2
};

export const getScaleFromResolution = (epsg, resolution, dpi, nearest = true) => {
    if(!epsg)
        return;
    const projection = getProjection(epsg);
    if(projection && resolution){
        const _units = projection.getUnits();
        const _mpu = projection.getMetersPerUnit();
        const _dpi = dpi || DEFAULT_SCREEN_DPI;
        const _inchesPerMeter = 1000 / 25.4;
        const scale = parseFloat(resolution.toString()) * _mpu * _inchesPerMeter * _dpi;
        return nearest ? Math.round(scale) : scale;
    }
    return null;
};